import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';

import { getContractWatcher } from '../../resources/contract';
import { discussionWatcher } from '../../resources/discussion';
import { getInTripReviewsRequestWatcher } from '../../resources/in-trip-review';
import { messageTemplatesWatcher } from '../../resources/message-template';
import { getPreTripReviewsRequestWatcher } from '../../resources/pre-trip-review';

export function* rootSaga(): SagaIterator {
    yield all([
        fork(discussionWatcher),
        fork(messageTemplatesWatcher),
        fork(getContractWatcher),
        fork(getPreTripReviewsRequestWatcher),
        fork(getInTripReviewsRequestWatcher),
    ]);
}
